import { FieldOption } from "../../../../../CygnusFormBuilder/CygnusFormBuilder.utils";
import { FieldProps } from "../../../../../InputFieldsController/InputFieldsController.utils";
import {
  HeaderSelectOption,
  SelectOption,
} from "../../CygnusFormBuilderToolbar.utils";

/**
 * Utility functions for FieldConfigurator
 */
export interface FieldConfiguratorProps {
  isFinal: boolean;
  fieldOptions: FieldOption[];
  selectedField: FieldProps;
  updateField: (partial: Partial<FieldProps>) => void;
  removeField: (id: string) => void;
}

/**
 * Finds a select option from a grouped list of input options by type.
 *
 * @param {any[]} inputOptions - Grouped input options (with label and options[])
 * @param {string} type - The field type to match (e.g., "text", "select", etc.)
 * @returns {SelectOption} The matched option, or fallback to "text" option
 */
export const findInputOptionByType = (
  inputOptions: any,
  type: string
): SelectOption => {
  for (const group of inputOptions) {
    const match = group.options.find(
      (opt: { value: string }) => opt.value === type
    );
    if (match) return match;
  }
  // fallback to "text" (assumes it's the first option in the "Inputs" group)
  return inputOptions[1].options[0];
};

/**
 * Finds a select option from a grouped list of input options by type.
 *
 * @param {any[]} options - Grouped input options (with label and options[])
 * @param {string} value - The field type to match (e.g., "text", "select", etc.)
 * @returns {SelectOption} The matched option, or fallback to "text" option
 */
export const findOptionByValue = (
  options: any,
  value: string
): any => {
  const match = options.find((opt: { value: string }) => opt.value === value);
  if (match) return match;
  // fallback to the first option in options group
  return match;
};

/**
 * Finds a select option from a flat list by matching its label.
 *
 * @param {SelectOption[]} options - The list of options to search from
 * @param {string} label - The label to match
 * @returns {SelectOption | undefined} The matched select option, or undefined if not found
 */
export const findSelectOptionByLabel = (
  options: SelectOption[],
  label: string
): SelectOption | undefined => {
  return options.find((opt) => opt.label === label);
};

/**
 * Finds a select option from a flat list by matching its value.
 *
 * @param {SelectOption[]} options - The list of options to search from
 * @param {string | number} value - The value to match
 * @returns {SelectOption | undefined} The matched select option, or undefined if not found
 */
export const findSelectOptionByValue = (
  options: HeaderSelectOption[],
  value: string | number | undefined
): HeaderSelectOption | undefined => {
  return options.find((opt) => opt.value === value);
};
